import React from 'react';
import { Link } from 'react-router-dom';

const DriverInfo = ({ carDetails = {}, driverDetails = null, driverLoading = false, formatDate = (d) => d }) => {
    // Normalize possible phone and drive link fields
    const phone = driverDetails?.phone || driverDetails?.phone_number || driverDetails?.mobile || driverDetails?.contact_phone || driverDetails?.contact_phone_number || driverDetails?.telephone || driverDetails?.tel;
    const driveLink = driverDetails?.drive_link || driverDetails?.driver_link || driverDetails?.link || driverDetails?.profile_link || driverDetails?.document_link;
    return (
        <div className="bg-gray-50 rounded-sm border border-gray-200 p-3">
            <h3 className="text-xs font-bold text-[#2a2e30] mb-2.5 flex items-center">
                <div className="w-2 h-2 bg-[#FF5733] rounded-full mr-2"></div>
                Driver
            </h3>
            <div className="space-y-2 text-xs">
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Name:</span>
                    {carDetails.driver_name ? (
                        <Link
                            to={carDetails.driver_id ? `/drivers?id=${carDetails.driver_id}` : "/drivers"}
                            className="text-[#FF5733] hover:text-[#e64a2b] transition-colors duration-200 font-medium text-xs xl:text-right xl:min-w-0 xl:truncate"
                            title={carDetails.driver_name}
                        >
                            {carDetails.driver_name}
                        </Link>
                    ) : (
                        <span className="text-gray-400">N/A</span>
                    )}
                </div>

                {driverLoading ? (
                    <div className="text-center py-1">Loading...</div>
                ) : driverDetails ? (
                    <>
                        {driverDetails.license_expiry && (
                            <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                                <span className="text-gray-700 font-medium">License Expiry:</span>
                                <span className={`font-medium text-xs ${
                                    (() => {
                                        const exp = new Date(driverDetails.license_expiry);
                                        const now = new Date();
                                        const daysLeft = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
                                        if (daysLeft < 0) return 'text-red-600 font-bold';
                                        if (daysLeft <= 30) return 'text-orange-500 font-bold';
                                        return 'text-[#2a2e30]';
                                    })()
                                }`}>
                                    {formatDate(driverDetails.license_expiry)}
                                </span>
                            </div>
                        )}

                        {carDetails.assigned_date && (
                            <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                                <span className="text-gray-700 font-medium">Assignment Date:</span>
                                <span className="font-medium text-[#2a2e30] text-xs xl:text-right">{formatDate(carDetails.assigned_date)}</span>
                            </div>
                        )}
                        {/* Driver phone */}
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Phone:</span>
                            {phone ? (
                                <a className="font-semibold text-[#2a2e30] text-xs" href={`tel:${phone}`}>{phone}</a>
                            ) : (
                                <span className="text-gray-400">N/A</span>
                            )}
                        </div>

                        {/* Drive link / profile link */}
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Drive Link:</span>
                            {driveLink ? (
                                <a className="text-xs text-blue-600 hover:underline" href={driveLink} target="_blank" rel="noreferrer noopener">Open</a>
                            ) : (
                                <span className="text-gray-400">N/A</span>
                            )}
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default DriverInfo;
